import styled from 'styled-components';
import { Container } from '../../styles/Common';

const Partners = () => {
  return (
    <Wrapper>
      <Container>
        <Headings>
          <h2>
            Trusted by over <br /> 10k clients & brands
          </h2>
          <p>
            Other agencies just can't compete... We don't mean to call anyone
            out but if we showcased their designs on our website it would
            completely throw off the industry leading aesthetics we strive for.
          </p>
        </Headings>
        <PartnersImage>
          <img src="/assets/images/our-partners.png" alt="our-partners" />
        </PartnersImage>
      </Container>
    </Wrapper>
  );
};

export default Partners;

const Wrapper = styled.div`
  padding: 100px 0;

  @media (max-width: 1024px) {
    padding: 40px 0;
  }
`;

const Headings = styled.div`
  margin-bottom: 80px;
  flex-direction: column;
  display: flex;
  align-items: center;

  @media (max-width: 1024px) {
    margin-bottom: 20px;
  }

  h2 {
    font-weight: 600;
    font-size: 40px;
    font-family: font-semibold;
    text-align: center;
    color: #181817;
    line-height: 1.5;
    margin-bottom: 20px;
    background: linear-gradient(90deg, #5ca6ed 0%, #b475f8 60%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;

    @media (max-width: 1024px) {
      font-size: 32px;
      margin-bottom: 10px;
    }
  }

  p {
    font-weight: 500;
    font-size: 18px;
    text-align: center;
    font-family: font-medium;
    color: rgb(152, 159, 179);
    line-height: 1.5;
    max-width: 50ch;

    @media (max-width: 1024px) {
      margin-bottom: 30px;
    }
  }
`;

const PartnersImage = styled.div`
  img {
    width: 100%;
    height: auto;
    user-select: none;
  }
`;
